import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { motion } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from "../axios/axios";
import Swal from "sweetalert2";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Para idioma español
import { useSelector } from 'react-redux';
import { styleBtn, textFieldStyle } from "./Styles";

const ContratoIndividual = () => {
    const tkn = useSelector((state) => state.tknAuth)
    const [isLoading, setIsLoading] = useState(false)

    const [tipoPrestamo, setTipoPrestamo] = useState(0)
    const [tipoPrestamoValue, setTipoPrestamoValue] = useState(0)
    const [catTipoPrestamo, setCatTipoPrestamo] = useState([])

    const [tipoPago, setTipoPago] = useState(0)

    const [catTipoPago, setCatTipoPago] = useState([])

    const [clienteContrato, setClienteContrato] = useState(null)
    const [catClientes, setCatClientes] = useState([])

    const [fechaComienzaContrato, setFechaComienzaContrato] = useState(null)
    const [fechaPrimerPago, setFechaPrimerPago] = useState(null)

    const [cantidadPrestar, setCantidadPrestar] = useState(0)
    const [cantidadPrestarFormateada, setCantidadPrestarFormateada] = useState(0)

    const [porcentajeInteres, setPorcentajeInteres] = useState('')
    const [mesesContrato, setMesesContrato] = useState('')
    const [interesPermitidoMin, setInteresPermitidoMin] = useState('')
    const [interesPermitidoMax, setInteresPermitidoMax] = useState('')
    const [cantidadPrestarMin, setCantidadPrestarMin] = useState('')
    const [cantidadPrestarMax, setCantidadPrestarMax] = useState('')
    const [garantiaPrestaria, setGarantiaPrestaria] = useState(0)
    const [garantiaPrestariaText, setGarantiaPrestariaText] = useState('')
    const [pagarSoloInteres, setPagarSoloInteres] = useState(false)


    const consultarCatalogos = () => {


        const catalogos = async () => {

            try {
                setIsLoading(true)

                //sacar rol del token
                const rolId = tkn.rolId

                const cats = await apiCumbres.get(`/registrar-contrato/catalogos/${rolId}`, {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setCatTipoPrestamo(cats.data.tipoPrestamos)
                setCatTipoPago(cats.data.tipoPagos)
                setCatClientes(cats.data.catClientes)
                setInteresPermitidoMin(cats.data.interesPermitido.interesPermitidoMin)
                setInteresPermitidoMax(cats.data.interesPermitido.interesPermitidoMax)

                setIsLoading(false)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener catalogos, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }


        catalogos()

    }

    useEffect(() => {
        consultarCatalogos()
    }, [])

    const shouldDisableDate = (date) => {
        const day = date.date();
        // Solo permite días 1 y 16
        if (day !== 1 && day !== 16) return true;

        // Deshabilita fechas anteriores a hoy
        return date.isBefore(dayjs(), 'day');
    };


    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const handleCantidadPrestar = (e) => {
        const input = e.target.value;

        const cleaned = input.replace(/,/g, '').replace(/[^\d.]/g, '');

        const parts = cleaned.split('.');
        if (parts.length > 2) return;

        // Guardar como número
        const numero = parseFloat(cleaned);

        const formateado = formatNumber(cleaned);

        setCantidadPrestar(isNaN(numero) ? 0 : numero)
        setCantidadPrestarFormateada(isNaN(numero) ? 0 : '$ ' + formateado)
    }

    const registrarContrato = () => {
        //setIsLoading(true)
        //validar dependiendo del tipo de prestamo la cantidad
        Swal.fire({
            title: "Esta seguro?",
            text: `Se registrara contrato con la información seleccionada!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, registrar!"
        }).then((result) => {
            
            if (!result.isConfirmed) return

            const jContrato = [
                { label: 'Cantidad a Prestar', cantidadPrestar },
                { label: 'Tipo Prestamo', tipoPrestamoId: tipoPrestamo },
                { label: 'Tipo Pago', tipoPagoId: tipoPago },
                { label: 'Cliente', cliente: clienteContrato },
                { label: 'Comienza Contrato', fechaComienzaContrato },
                { label: 'Primer Pago', fechaPrimerPagoContrato: fechaPrimerPago },
                { label: 'Interes', interes: porcentajeInteres },
                { label: 'Meses', meses: mesesContrato },
            ]

            if (garantiaPrestaria === '1') {
                jContrato.push({ label: 'Garantia Prestaria', garantiaPrestaria: garantiaPrestariaText })
                jContrato.push({label: 'Solo Interes', pagarSoloInteres})
                //if (garantiaPrestariaText) jContrato.push({ label: 'Garantia Prestaria', garantiaPrestaria: garantiaPrestariaText })
            }

            // Validar que todos los campos tengan valor
            const emptyField = jContrato.find(f => {
                const value = Object.values(f)[1]; // segundo valor del objeto

                // Si es un array, debe tener al menos 1 elemento
                if (Array.isArray(value)) return value.length === 0;

                // Si es un número, debe ser mayor que 0
                if (typeof value === 'number') return value <= 0;

                // Si es string, debe tener contenido
                return !value?.toString().trim();
            });

            if (emptyField) {
                toast.error(`El campo "${emptyField.label}" es obligatorio.`, toast_config);
                return;
            }

            if (cantidadPrestar < cantidadPrestarMin) return toast.error(`La cantidad mínima del préstamo que escogiste es $ ${formatNumber(cantidadPrestarMin)}`)
            if (cantidadPrestar > cantidadPrestarMax) return toast.error(`La cantidad máximo del préstamo que escogiste es $ ${formatNumber(cantidadPrestarMax)}`)

            if (porcentajeInteres < interesPermitidoMin || porcentajeInteres > interesPermitidoMax) return toast.error(`El rango de interés que tienes permitido para este préstamo es mínimo de ${interesPermitidoMin}% y el máximo es ${interesPermitidoMax}%`)

            const registrar = async () => {

                try {

                    setIsLoading(true)

                    jContrato.push({ label: 'usuario', usuario: tkn.usuarioId })

                    const regContrato = await apiCumbres.post('/registrar-contrato/crear', jContrato, {
                        headers: {
                            //token
                        }
                    })

                    setIsLoading(false)
                    Swal.fire({
                        icon: 'success',
                        title: 'Enhorabuena!',
                        text: regContrato.data.mensaje
                    }).then((result) => {
                        window.location.href = '/registrar-contrato'
                    });

                } catch (error) {
                    let msg_error = ''
                    if (error.response) {
                        console.log(error.response)
                        if (error.response.data.error) {
                            msg_error = error.response.data.error
                        } else {
                            msg_error = 'Ocurrió un error al registrar contrato, favor de volver a intentarlo!'
                        }
                    } else {
                        console.log(error)
                        msg_error = 'No hay respuesta por parte del servidor!'
                    }
                    //mensaje de toastify
                    setIsLoading(false)
                    toast.error(msg_error, toast_config)
                }

            }

            registrar()
        })



    }

    const handleTipoPrestamo = (tp) => {

        setTipoPrestamo(tp.tipoPrestamoId)
        setTipoPrestamoValue(tp)
        setCantidadPrestarMin(tp.cantidadMin)
        setCantidadPrestarMax(tp.cantidadMax)
        setGarantiaPrestaria(tp.garantiaPrestaria)
        setGarantiaPrestariaText('')

    }

    const options = catClientes.map(cliente => ({
        id: cliente.clienteId,
        label: `${cliente.nombre} ${cliente.paterno} ${cliente.materno}`
    }));

    const selectedOptionCliente = options.find(op => op.id === clienteContrato) || null;


    return (

        <div className="container">
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="row">
                <div className="col-md-12">
                    <div
                        className="card shadow-lg  p-5 border-0"
                        style={{ borderRadius: '20px' }}
                    >

                        <div className="row">

                            <motion.h1 className="color-primary"
                                initial={{ opacity: 0, y: -90 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                Registrar Contrato Individual
                            </motion.h1>
                            <hr className="mb-5" />

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 1 }}
                            >
                                <FormControl fullWidth sx={textFieldStyle}>
                                    <InputLabel id="demo-simple-select-label">Tipo Préstamo</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={tipoPrestamoValue}
                                        label="Tipo Prestamo"
                                        onChange={(e) => handleTipoPrestamo(e.target.value)}

                                    >
                                        <MenuItem key={0} value={0} disabled>-SELECCIONAR TIPO DE PRÉSTAMO</MenuItem>
                                        {catTipoPrestamo && catTipoPrestamo.map((tp) => (
                                            <MenuItem key={tp.tipoPrestamoId} value={tp}>{tp.tipoPrestamo}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 2 }}
                            >
                                <FormControl fullWidth sx={textFieldStyle} disabled={!tipoPrestamo}>
                                    <InputLabel id="demo-simple-select-label">Tipo Pago</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"

                                        value={tipoPago}
                                        label="Tipo Pago"
                                        onChange={(e) => setTipoPago(e.target.value)}

                                    >
                                        <MenuItem key={0} value={0} disabled>-SELECCIONAR TIPO DE PAGO</MenuItem>
                                        {catTipoPago && catTipoPago.map((tp) => (
                                            <MenuItem key={tp.tipoPagoId} value={tp.tipoPagoId}>{tp.tipoPago}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 3 }}
                            >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Seleccionar Comienzo Contrato"
                                        value={fechaComienzaContrato}
                                        onChange={(newValue) => setFechaComienzaContrato(newValue)}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                variant: "outlined",
                                                sx: { textFieldStyle },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 4 }}
                            >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        disabled={!tipoPago || !tipoPrestamo}
                                        label="Seleccionar Primer Pago Contrato"
                                        value={fechaPrimerPago}
                                        onChange={(newValue) => setFechaPrimerPago(newValue)}
                                        shouldDisableDate={shouldDisableDate}
                                        minDate={dayjs()} // Evita fechas pasadas
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                variant: "outlined",
                                                sx: { textFieldStyle },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 5 }}
                            >
                                <FormControl sx={textFieldStyle} fullWidth>

                                    <Autocomplete
                                        disablePortal
                                        options={catClientes.map((cliente) => ({ id: cliente.clienteId, label: `${cliente.nombre} ${cliente.paterno} ${cliente.materno}` }))}
                                        onChange={(event, newValue) => setClienteContrato(newValue ? newValue.id : null)}
                                        getOptionLabel={(option) => option.label}
                                        value={selectedOptionCliente}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => <TextField {...params} label="Cliente" variant='outlined' />}
                                    />
                                </FormControl>

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 6 }}
                            >
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label='Cantidad a Prestar'
                                    sx={textFieldStyle}
                                    value={cantidadPrestarFormateada}
                                    onChange={handleCantidadPrestar}
                                />

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 7 }}
                            >
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label='% Interes'
                                    sx={textFieldStyle}
                                    value={porcentajeInteres}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Permitir solo números enteros del 1 al 18
                                        if (/^\d*$/.test(value)) { // Solo dígitos
                                            const number = parseInt(value, 10);
                                            if ((number >= 1 && number <= 18) || value === "") {
                                                setPorcentajeInteres(value);
                                            }
                                        }
                                    }}
                                />

                            </motion.div>

                            <motion.div
                                className="col-md-6 mb-3"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 8 }}
                            >
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label='Meses Duración'
                                    sx={textFieldStyle}
                                    value={mesesContrato}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Permitir solo números enteros del 1 al 18
                                        if (/^\d*$/.test(value)) { // Solo dígitos
                                            const number = parseInt(value, 10);
                                            if ((number >= 1 && number <= 24) || value === "") {
                                                setMesesContrato(value);
                                            }
                                        }
                                    }}
                                />

                            </motion.div>

                            {garantiaPrestaria === '1' &&
                                <>
                                    <motion.div
                                        className="col-md-6 mb-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 1 }}
                                    >
                                        <TextField
                                            multiline
                                            rows={2}
                                            variant="outlined"
                                            fullWidth
                                            label='Garantia Prestaria'
                                            sx={textFieldStyle}
                                            value={garantiaPrestariaText}
                                            onChange={(e) => setGarantiaPrestariaText(e.target.value)}
                                        />

                                    </motion.div>
                                    <motion.div
                                        className="col-md-6 mb-3"
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 * 1 }}
                                    >
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox defaultChecked />} label="Poder pagar puro interes" value={pagarSoloInteres} onChange={() => setPagarSoloInteres(!pagarSoloInteres)} />
                                        </FormGroup>

                                    </motion.div>
                                </>



                            }

                            <motion.div
                                className="col-md-12 mt-3"
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.9 }}
                                whileHover={{
                                    y: -4,
                                    scale: 1.03,
                                    filter: "brightness(1.1)",
                                    transition: { duration: 0.25, ease: "easeOut" },
                                }}
                            >
                                <Button variant="contained" fullWidth sx={styleBtn} onClick={registrarContrato} >
                                    Registrar
                                </Button>
                            </motion.div>



                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>

    )

}

export default ContratoIndividual